import {Record, List} from 'immutable';

const DEFAULT_STATE = {
  columns: List(),
};

const BaseRecord = Record(DEFAULT_STATE);

export class ColumnSetRecord extends BaseRecord {

  addImage(image) {
    const targetColumn = this.shortestColumn;
    const columnIndex = this.columns.indexOf(this.shortestColumn);
    return this.setIn(['columns', columnIndex], targetColumn.addImage(image));
  }

  get shortestColumn() {
    if (this.columns.count() < 1) {
      throw new Error('At least one column must be specified');
    }

    if (this.columns.count() === 1) {
      return this.columns.first();
    }

    return this.columns.sort((a, b) => a.height > b.height ? 1 : -1).first();
  }
}



// WEBPACK FOOTER //
// ./src/state/images/ColumnSetRecord.js